import React from 'react'
import { Button, Container, Row, Col, Label, Input } from 'reactstrap'
import '../css/QuoteViewController.css'
import {
    getCompanyBankNickNames,
    deleteBank,
    insertBank,
} from '../model/request/bank'

class EditPaymentInfoViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'nick_name': '',
            'ada_routing_number': '',
            'account_number': '',
            'account_title': '',
            'banks': [],
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()
        getCompanyBankNickNames().then(
            (banks) => {
                this.setState({
                    'banks': banks,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    addBankClicked() {
        this.props.turnOffLoader()
        insertBank(
            this.state.nick_name,
            this.state.ada_routing_number,
            this.state.account_number,
            this.state.account_title,
        ).then(
            (bank) => {
                this.setState((state) => {
                    const banks = [...state.banks]
                    banks.push({
                        'id': bank.id,
                        'nick_name': bank.nick_name
                    })
                    return {
                        'banks': banks,
                        'nick_name': '',
                        'ada_routing_number': '',
                        'account_number': '',
                        'account_title': '',
                    }
                })
                this.props.turnOffLoader()
            },
            (error) => {
                console.log(error)
                this.props.showError(error)
                this.props.turnOffLoader()
            },
        )

    }

    deleteBank(index) {
        this.props.turnOffLoader()
        let banks = this.state.banks
        const id = banks[index].id
        banks = [
            ...banks.slice(0,index),
            ...banks.slice(index+1),
        ]
        deleteBank(id).then(
            (success) => {
                this.setState((state) => {
                    return {
                        'banks': banks,
                    }
                })
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    renderLabelTable(label, table) {
        return <>
            <Row>
            <Col><Label
                style={{
                    'fontSize': '18pt',
                    'fontWeight': '400',
                }}
            >{label}</Label>
            </Col>
            </Row>
        {table}
        </>
    }

    renderHeaderLabelAndBody(label, body) {
        return <>
        <Row>
            <Col><Label
                style={{
                    'fontSize': '16pt',
                    'fontWeight': '350',
                }}
            >{label}</Label></Col>
        </Row>
        <Row>
            <Col>{body}</Col>
        </Row>
        </>
    }

    renderInput(varname) {
        return <Input
            type='text'
            value={this.state[varname]}
            onChange={(e) => {
                const newState = {}
                newState[varname] = e.target.value
                this.setState(newState)
            }}
            />
    }

    render() {
        return <Container>
            {this.renderLabelTable('Banks', <Col><Container>
                <Row>
                    <Col><Label
                        style={{
                            'fontWeight': '400',
                        }}
                    >Nick Names</Label></Col>
                    <Col><Label
                        style={{
                            'fontWeight': '400',
                        }}
                    >Delete</Label></Col>
                </Row>
                {this.state.banks.map((e, bankIndex) => 
                    <Row
                        style={{
                            'marginTop': '8px',
                            'marginBottom': '8px',
                        }}
                    >
                        <Col>
                            <Label>{e.nick_name}</Label>
                        </Col>
                        <Col>
                            <Button
                                onClick={() => {
                                    this.deleteBank(bankIndex)
                                }}
                                color='danger'
                            >Delete</Button>
                        </Col>
                    </Row>
                )}
                <Row>
                <Col>
                {this.renderHeaderLabelAndBody(
                    'Nick Name',
                    this.renderInput('nick_name'),
                )}
                </Col>
                <Col>
                {this.renderHeaderLabelAndBody(
                    'ADA Routing Number',
                    this.renderInput('ada_routing_number'),
                )}
                </Col>
                <Col>
                {this.renderHeaderLabelAndBody(
                    'Account Number',
                    this.renderInput('account_number'),
                )}
                </Col>
                <Col>
                {this.renderHeaderLabelAndBody(
                    'Account Title',
                    this.renderInput('account_title'),
                )}
                </Col>
                </Row>
            </Container>
            </Col>)}
            <Row
                style={{
                    'marginTop': '20px',
                }}
            ><Col
                style={{
                    'textAlign': 'right',
                }}
            ><Container><Button
                color='success'
                onClick={() => {
                    this.addBankClicked()
                }}
            >Add Bank</Button></Container></Col></Row>
        </Container>
    }
}

export default EditPaymentInfoViewController;
